import * as React from "react";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";

import { LoadingButton } from "@mui/lab";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  Stack,
  Switch,
  TextField,
  Typography
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { Input, message } from "antd";

import moment from "moment";

import SendBackModal from "Pages/B2BPaymentPortal/components/SendBackModal/SendBackModal";
import { setQRCode } from "Pages/VehicleListingPage/action";
import {
  fetchSummary,
  setCurrentCardStep,
  syncEEData,
  PhotographyQcComplete,
  getCheckList,
  updateVehicleSegment,
  fetchPricing,
  updateRefurbEstimateDateInStore
} from "Pages/VehicleSummary/action";

import DialogModal from "Components/UI/Dialog/DialogModal";

import formService from "Network/lib/formService";
import vehicleService from "Network/lib/vehicleService";
import vehicleSummaryService from "Network/lib/vehicleSummaryService";

import EditStatusModal from "./EditStatusModal";

const actionContent = {
  RECALL_RESOLVED: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>recall resolved?</strong>?
      </Typography>
    )
  },
  WRONG_ENTRY: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>wrong entry?</strong>?
      </Typography>
    )
  },
  OUTSTANDING_RECALL: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>outstanding recall?</strong>?
      </Typography>
    )
  },
  SOURCING_CANCELLATION: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>cancel?</strong>?
      </Typography>
    )
  },
  APPROVE_SOURCING_CANCELLATION: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>approve sourcing cancellation?</strong>?
      </Typography>
    )
  },
  REJECT_SOURCING_CANCELLATION: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>reject sourcing cancellation?</strong>?
      </Typography>
    )
  },
  NO_ACTIVE_RECALL: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>no actice recall</strong>?
      </Typography>
    )
  },
  SYNC_EE: {
    title: () => <Typography>Sync EE/Glasses data?</Typography>
  },
  PHOTOGRAPHY_QC_COMPLETE: {
    title: () => <Typography>Mark photo QC complete?</Typography>
  },
  SYNC_PP: {
    title: () => <Typography>Sync post purchase?</Typography>
  },
  RE_PUBLISH: {
    title: () => <Typography>Are you sure you want to republish this vehicle</Typography>
  },
  UN_PUBLISH: {
    title: () => <Typography>Are you sure you want to unpublish this vehicle</Typography>
  },
  PUBLISHING_QC: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>publishing QC complete</strong>?
      </Typography>
    )
  },
  PUBLISH: {
    title: () => (
      <Typography>
        Are you sure you want to mark this vehicle as <strong>publish</strong>?
      </Typography>
    )
  },
  REVERSE_SOURCING_CANCELLATION: {
    title: () => <Typography>Are you sure you want to reverse sourcing cancellation of this vehicle?</Typography>
  },
  UPDATE_LUXURY_CAR_STATUS: {
    title: () => <Typography>Are you sure you want to update the luxury car status?</Typography>
  },
  PRE_PUBLISH_CAR: {
    title: () => <Typography>Are you sure you want to pre publish this vehicle?</Typography>
  },
  UPDATE_NO_REFURB: {
    title: () => <Typography>Update No Refurb status</Typography>
  }
};

function UpdateVinModal({ updateVinModal, setUpdateVinModal }) {
  const [vin, setVin] = React.useState("");
  const [showError, setShowError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

  const vehicleData = useSelector((state) => state.vehicleSummary.data);

  const prevVin = (Object.keys(vehicleData).length > 0 && vehicleData.vehicleInfo.vin) || null;

  // eslint-disable-next-line no-nested-ternary
  const errorText = vin.includes("O")
    ? "Letter 'O' is not allowed in VIN number"
    : vin.trim().length !== 17
    ? "Please enter 17 digits VIN number"
    : "";

  const handleSubmitClick = () => {
    setLoading(true);
    const payload = {
      action: "UPDATE_VIN",
      leadId: vehicleData.vehicleInfo.leadId,
      appointmentId: vehicleData.vehicleInfo.appointmentId,
      vehicleDetails: {
        vin
      }
    };
    vehicleSummaryService
      .updatePrice(payload)
      .then(() => {
        setLoading(false);
        setUpdateVinModal(false);
        setVin("");
        setShowError(false);
        dispatch(fetchSummary(vehicleData.vehicleInfo.leadId));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const closeVinModal = () => {
    setUpdateVinModal(false);
    setVin("");
    setShowError(false);
  };

  return (
    <DialogModal
      isModalOpen={updateVinModal}
      setIsModalOpen={closeVinModal}
      heading="Update Vin"
      width="556px"
      buttonDetails={{
        btnTitle: "Update",
        disableBtn: errorText.length > 0 || prevVin.toUpperCase() === vin.toUpperCase(),
        handleBtnClick: handleSubmitClick,
        loading
      }}
    >
      <Typography mt="3.2rem" mb="1.2rem" fontWeight={600}>
        VIN
      </Typography>
      <Input
        style={{ width: "100%" }}
        placeholder="e.g. JTELV73J20B038664"
        value={vin}
        onInput={(e) => {
          const regex = /^[a-zA-Z0-9]+$/;

          if (regex.test(e.target.value) || e.target.value === "") {
            const vinInput = `${e.target.value}`.toUpperCase();
            setVin(vinInput);
          }

          if (!showError) {
            setShowError(true);
          }
        }}
      />
      {showError && (
        <Typography fontSize={["1.4rem"]} mt="1rem" color="#ff4d4f">
          {errorText}
        </Typography>
      )}
    </DialogModal>
  );
}

function ActionModal({ ctaType, isNoRefurb, loading, open, onClose, onNoRefurbChange, onOk }) {
  if (!open) return null;

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      onBackdropClick={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>
        <Typography fontWeight="bold">{actionContent[ctaType]?.title()}</Typography>
      </DialogTitle>
      {ctaType === "UPDATE_NO_REFURB" && (
        <DialogContent>
          <FormControlLabel
            control={<Switch checked={isNoRefurb} onChange={(event) => onNoRefurbChange(event.target.checked)} />}
            label={isNoRefurb ? "No Refurb" : "Send for Refurb"}
          />
        </DialogContent>
      )}
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={loading} onClick={onOk}>
          Ok
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

function CommentModal({ loading, open, onClose, onOk }) {
  const [value, setValue] = React.useState("");

  if (!open) return null;

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      onBackdropClick={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>
        <Typography fontWeight="bold">Cancellation Reason (Optional)</Typography>
      </DialogTitle>
      <DialogContent>
        <TextField
          multiline
          rows={4}
          value={value}
          onChange={handleChange}
          sx={{
            width: "100%"
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={loading} onClick={() => onOk(value)}>
          Ok
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

function EstimatedRefurbDateModal({ loading, open, onClose, onOk, prefilledDate }) {
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState("");
  const [pickerOpen, setPickerOpen] = React.useState(false);

  const formatDateInput = React.useCallback((rawValue) => {
    const digits = rawValue.replace(/\D/g, "").slice(0, 8);

    if (digits.length <= 2) return digits;
    if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;

    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
  }, []);

  React.useEffect(() => {
    if (!open) {
      setValue(null);
      setInputValue("");
      setPickerOpen(false);
      return;
    }

    const parsedPrefilledDate = moment(prefilledDate, ["YYYY-MM-DD", "DD/MM/YYYY", moment.ISO_8601], true);

    if (parsedPrefilledDate.isValid()) {
      setValue(parsedPrefilledDate);
      setInputValue(parsedPrefilledDate.format("DD/MM/YYYY"));
      return;
    }

    setValue(null);
    setInputValue("");
  }, [open, prefilledDate]);

  const handleDateChange = (newValue) => {
    setValue(newValue);
    setInputValue(newValue && moment(newValue).isValid() ? moment(newValue).format("DD/MM/YYYY") : "");
  };

  const handleInputChange = (event) => {
    const formattedValue = formatDateInput(event.target.value);

    setInputValue(formattedValue);

    if (formattedValue.length === 10) {
      const parsedDate = moment(formattedValue, "DD/MM/YYYY", true);

      setValue(parsedDate.isValid() ? parsedDate : null);
      return;
    }

    setValue(null);
  };

  if (!open) return null;

  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="xs"
      open={open}
      onBackdropClick={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle>
        <Typography fontWeight="bold">Update Estimated Refurb Date</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>Select the estimated refurb date.</DialogContentText>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            open={pickerOpen}
            onOpen={() => setPickerOpen(true)}
            onClose={() => setPickerOpen(false)}
            value={value}
            onChange={handleDateChange}
            inputFormat="DD/MM/YYYY"
            disableMaskedInput
            OpenPickerButtonProps={{
              "aria-label": "select estimated refurb date"
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                value={inputValue}
                onChange={handleInputChange}
                onClick={() => setPickerOpen(true)}
              />
            )}
          />
        </LocalizationProvider>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose}>
          Cancel
        </Button>
        <LoadingButton loading={loading} disabled={!moment(value).isValid()} onClick={() => onOk(value)}>
          Ok
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default function VehicleActionList(props) {
  const { actions = [], appointmentId, leadId } = props;
  const history = useHistory();
  const {
    vehicleSummary: {
      data: {
        paymentsDetails: { c2bOrderId } = {},
        vehicleInfo: { source = "", refurbEstimateDate: vehicleInfoRefurbEstimateDate } = {},
        refurbEstimateDate: summaryRefurbEstimateDate
      }
    }
  } = useSelector((state) => state);

  const { vehicleStatusConfig = {} } = useSelector((state) => state.app);
  const pricingData = useSelector((state) => state.vehicleSummary.pricingDetails?.data) || {};
  const listingPrice = pricingData.egcPrice;

  const sourcingPlatformId = c2bOrderId;
  const isC2B = source === "C2B";
  const refurbEstimateDate = vehicleInfoRefurbEstimateDate || summaryRefurbEstimateDate;
  const [clientRefurbEstimateDate, setClientRefurbEstimateDate] = React.useState(refurbEstimateDate || null);
  const [actionModal, setActionModal] = React.useState({ open: false, loading: false, ctaType: "" });
  const [commentModal, setCommentModal] = React.useState(false);
  const [updateVinModal, setUpdateVinModal] = React.useState(false);
  const [editStatusModal, setEditStatusModal] = React.useState({ open: false, loading: false, statusOptions: [] });
  const [estimatedRefurbModal, setEstimatedRefurbModal] = React.useState({ open: false, loading: false });
  const [sendBackCtx, setSendBackCtx] = React.useState(null);

  const dispatch = useDispatch();

  React.useEffect(() => {
    setClientRefurbEstimateDate(refurbEstimateDate || null);
  }, [refurbEstimateDate]);

  const handleClick = (e, cta) => {
    e.stopPropagation();
    const ctaType = cta?.ctaType;

    switch (ctaType) {
      case "UPDATE_VAS_CAR_CATEGORY":
        dispatch(fetchSummary(leadId));
        break;
      case "EDIT_VEHICLE":
        dispatch(setCurrentCardStep(null));
        history.push(`/onboarding-form/${leadId}`);
        break;

      case "ADD_QC":
      case "EDIT_QC":
        history.push(`/quality-checkform/${leadId}`);
        break;

      case "ADD_PAYMENT":
        history.push(isC2B ? `/payment-form/${leadId}/${sourcingPlatformId}` : `/finance-receipt/${leadId}`);
        break;
      case "EDIT_PAYMENT": {
        history.push(`/finance-receipt/${leadId}/${cta?.params?.id}`);
        break;
      }

      case "QR_CODE":
        dispatch(
          setQRCode({
            open: true,
            content: props
          })
        );
        break;

      case "RECALL_RESOLVED":
      case "OUTSTANDING_RECALL":
      case "NO_ACTIVE_RECALL":
        setActionModal((prev) => ({
          ...prev,
          open: true,
          ctaType
        }));
        break;

      case "WRONG_ENTRY":
      case "SOURCING_CANCELLATION":
      case "APPROVE_SOURCING_CANCELLATION":
      case "REJECT_SOURCING_CANCELLATION":
      case "SYNC_EE":
      case "PHOTOGRAPHY_QC_COMPLETE":
      case "SYNC_PP":
      case "UN_PUBLISH":
      case "RE_PUBLISH":
      case "PUBLISHING_QC":
      case "PUBLISH":
      case "REVERSE_SOURCING_CANCELLATION":
      case "UPDATE_LUXURY_CAR_STATUS":
      case "PRE_PUBLISH_CAR":
        setActionModal((prev) => ({
          ...prev,
          open: true,
          ctaType
        }));
        break;
      case "UPDATE_NO_REFURB":
        setActionModal({ ctaType, isNoRefurb: true, loading: false, open: true });
        break;
      case "EDIT_STATUS":
        if (appointmentId && !pricingData.egcPrice) {
          dispatch(fetchPricing(appointmentId, 2));
        }
        setEditStatusModal({ open: true, loading: false, statusOptions: cta?.params?.statusOptions || [] });
        break;
      case "ESTIMATED_REFURB_DATE":
        setEstimatedRefurbModal({ open: true, loading: false });
        break;
      case "VEHICLE_APPROVAL_APPROVE": {
        const { caseId, stageType } = cta?.params || {};
        if (!caseId || !stageType) {
          message.error("Missing approval context");
          break;
        }
        vehicleSummaryService
          .approveVehicleStage(caseId, stageType)
          .then(() => {
            message.success("Approved");
            dispatch(fetchSummary(leadId));
          })
          .catch(() => message.error("Approval failed"));
        break;
      }
      case "VEHICLE_APPROVAL_SEND_BACK": {
        const { caseId, stageType } = cta?.params || {};
        if (!caseId || !stageType) {
          message.error("Missing approval context");
          break;
        }
        setSendBackCtx({ caseId, stageType });
        break;
      }
      case "UPDATE_VIN":
        setUpdateVinModal(true);
        break;
      case "SOLD_QC_IMAGES":
        history.push(`/vehicle-summary/${leadId}/sold-qc-images?appointmentId=${appointmentId}`);
        break;
      default:
        history.push(`/vehicle-summary/${leadId}/vehicle-details`);
        break;
    }
  };

  return (
    <>
      <List style={{ marginTop: 0, paddingTop: 0 }}>
        {actions.map((action) => (
          <ListItem key={action.ctaType} disablePadding onClick={(e) => handleClick(e, action)}>
            <Stack direction="row" alignItems="center" component={ListItemButton} spacing={1}>
              <Typography component="span" variant="body2" color="#0071BC">
                {action.title}
              </Typography>
            </Stack>
          </ListItem>
        ))}
      </List>

      <ActionModal
        ctaType={actionModal.ctaType}
        isNoRefurb={actionModal.isNoRefurb ?? true}
        open={actionModal.open}
        loading={actionModal.loading}
        onClose={(e) => {
          e.stopPropagation();
          setActionModal({
            loading: false,
            ctaType: ""
          });
        }}
        onNoRefurbChange={(isNoRefurb) => setActionModal((prev) => ({ ...prev, isNoRefurb }))}
        onOk={(e) => {
          e.stopPropagation();

          if (["SOURCING_CANCELLATION"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, open: false }));
            setCommentModal(true);
          } else if (
            [
              "WRONG_ENTRY",
              "APPROVE_SOURCING_CANCELLATION",
              "REJECT_SOURCING_CANCELLATION",
              "UN_PUBLISH",
              "RE_PUBLISH",
              "PUBLISHING_QC",
              "PUBLISH",
              "REVERSE_SOURCING_CANCELLATION",
              "UPDATE_NO_REFURB"
            ].includes(actionModal.ctaType)
          ) {
            const qcPayload = {
              leadId,
              action: actionModal.ctaType,
              appointmentId
            };
            if (actionModal.ctaType === "UPDATE_NO_REFURB") {
              qcPayload.attributes = { isNoRefurb: actionModal.isNoRefurb };
            }

            setActionModal((prev) => ({ ...prev, loading: true }));
            formService
              .submitQc(qcPayload)
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false }));
              });
          } else if (["SYNC_EE"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, loading: true }));
            dispatch(syncEEData(appointmentId, true))
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          } else if (["PHOTOGRAPHY_QC_COMPLETE"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, loading: true }));
            dispatch(PhotographyQcComplete(appointmentId, true))
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
                dispatch(getCheckList(appointmentId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          } else if (["SYNC_PP"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, loading: true }));
            dispatch(syncEEData(appointmentId, false))
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          } else if (["UPDATE_LUXURY_CAR_STATUS"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, loading: true }));
            dispatch(updateVehicleSegment(appointmentId))
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          } else if (["PRE_PUBLISH_CAR"].includes(actionModal.ctaType)) {
            setActionModal((prev) => ({ ...prev, loading: true }));
            vehicleSummaryService
              .prePublishCar(appointmentId)
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          } else {
            setActionModal((prev) => ({ ...prev, loading: true }));
            vehicleService
              .updateRecallStatus(leadId, actionModal.ctaType)
              .then(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
                dispatch(fetchSummary(leadId));
              })
              .catch(() => {
                setActionModal((prev) => ({ ...prev, loading: false, ctaType: "", open: false }));
              });
          }
        }}
      />

      <CommentModal
        loading={actionModal.loading}
        open={commentModal}
        onClose={() => setCommentModal(false)}
        onOk={(comment) => {
          const qcPayload = {
            action: actionModal.ctaType,
            appointmentId,
            comment,
            leadId
          };

          setActionModal((prev) => ({ ...prev, loading: true }));
          formService
            .submitQc(qcPayload)
            .then(() => {
              setActionModal((prev) => ({ ...prev, loading: false, ctaType: "" }));
              dispatch(fetchSummary(leadId));
            })
            .catch(() => {
              setActionModal((prev) => ({ ...prev, loading: false, ctaType: "" }));
            });
        }}
      />
      <EstimatedRefurbDateModal
        loading={estimatedRefurbModal.loading}
        open={estimatedRefurbModal.open}
        prefilledDate={clientRefurbEstimateDate}
        onClose={(e) => {
          e.stopPropagation();
          setEstimatedRefurbModal({ open: false, loading: false });
        }}
        onOk={(value) => {
          const formattedRefurbEstimateDate = moment(value).format("YYYY-MM-DD");
          const payloadData = {
            refurbEstimateDate: formattedRefurbEstimateDate
          };

          setEstimatedRefurbModal((prev) => ({ ...prev, loading: true }));
          vehicleSummaryService
            .updateEstimatedRefurbDate(appointmentId, payloadData)
            .then(() => {
              setEstimatedRefurbModal({ open: false, loading: false });
              setClientRefurbEstimateDate(formattedRefurbEstimateDate);
              dispatch(updateRefurbEstimateDateInStore(formattedRefurbEstimateDate));
            })
            .catch(() => {
              setEstimatedRefurbModal((prev) => ({ ...prev, loading: false }));
            });
        }}
      />
      <UpdateVinModal updateVinModal={updateVinModal} setUpdateVinModal={setUpdateVinModal} leadId={leadId} />
      {sendBackCtx && (
        <SendBackModal
          isOpen={Boolean(sendBackCtx)}
          onClose={() => setSendBackCtx(null)}
          caseId={sendBackCtx.caseId}
          stageType={sendBackCtx.stageType}
          submitFn={vehicleSummaryService.sendBackVehicleStage}
          onSuccess={() => {
            setSendBackCtx(null);
            dispatch(fetchSummary(leadId));
          }}
        />
      )}
      <EditStatusModal
        isModalOpen={editStatusModal.open}
        setIsModalOpen={(val) => setEditStatusModal((prev) => ({ ...prev, open: val }))}
        statusOptions={editStatusModal.statusOptions}
        reasons={vehicleStatusConfig.reasons || {}}
        listingPrice={listingPrice}
        loading={editStatusModal.loading}
        onSubmit={({ status, reason, comment, amount }) => {
          const payload = {
            appointmentId,
            status,
            reason,
            comment,
            amount
          };
          setEditStatusModal((prev) => ({ ...prev, loading: true }));
          formService
            .updateVehicleStatus(payload)
            .then(() => {
              setEditStatusModal({ open: false, loading: false, statusOptions: [] });
              dispatch(fetchSummary(leadId));
            })
            .catch(() => {
              setEditStatusModal((prev) => ({ ...prev, loading: false }));
            });
        }}
      />
    </>
  );
}
